export default __webpack_public_path__ + "static/media/file-photo-circle-yellow.fffb9c16.svg";